<script>
import Base from "../Base";
import HasState from "./Mixins/HasState";
import HasData from "./Mixins/HasData";
import HasEditableParent from "./Mixins/HasEditableParent";
import NeedsSetableCssClasses from "../../Mixins/NeedsSetableCssClasses";

export default {
  extends: Base,
  mixins: [HasState, HasData, HasEditableParent, NeedsSetableCssClasses],
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    validation: {
      type: String,
    },
    hideLabelState: {
      type: String,
    },
    baseClass: {
      type: String,
      default: "editable__element",
    },
    typeClass: {
      type: String,
      default: "",
    },
    addClass: {
      type: String,
      default: "",
    },
    errorClass: {
      type: String,
      default: "state-error",
    },
    validClass: {
      type: String,
      default: "state-valid",
    },
    invalidClass: {
      type: String,
      default: "state-invalid",
    },
    noValueClass: {
      type: String,
      default: null,
    },
    noValueText: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      errors: [],
      validationResult: null,
      inputClass: "",
    };
  },
  computed: {
    text() {
      return this.hasValue ? this.data : this.noValText;
    },
    textClass() {
      if (!this.hasValue) {
        return this.noValClass;
      }

      return "";
    },
    baseClasses() {
      const baseClasses = [this.baseClass];

      if (this.typeClass) {
        baseClasses.push(`${this.baseClass}-${this.typeClass}`);
      }

      return baseClasses.concat(this.additionalBaseClasses);
    },
    containerClassModifiers() {
      return this.styleMod.concat([this.state]);
    },
    noValText() {
      return this.noValueText
        ? this.noValueText
        : this.parentEditable.noValText;
    },
    noValClass() {
      return this.noValueClass
        ? this.noValueClass
        : this.parentEditable.noValClass;
    },
  },
  created() {
    this.$emit("created", this);
  },
  methods: {
    clContainer(additionalClasses) {
      let containerClass =
        this.containerClasses.join(" ") + " " + additionalClasses;

      if (!this.hasValue) {
        containerClass += " " + this.clMod("novalue");
      }

      if (this.errors.length || this.validationResult === false) {
        containerClass += " " + this.clMod("error");
      }
      if (this.errors.length) {
        containerClass += " " + this.errorClass;
      }

      if (this.validationResult === true) {
        containerClass += " " + this.validClass;
      } else if (this.validationResult === false) {
        containerClass += " " + this.invalidClass;
      }

      return containerClass;
    },
    focused() {
      if (this.inputClass != "focused") {
        this.inputClass = "focused";
      }

      this.validate();
    },
    validate() {
      this.parentEditable.validate();
    },
    setErrors(errors) {
      if (errors === null) {
        errors = [];
      } else if (this.namePath.length > 1) {
        this.namePath.slice(1).forEach((pathPart) => {
          if (pathPart in errors) {
            errors = errors[pathPart];
          }
        });
      } else if (
        this.valueName &&
        typeof errors == "object" &&
        errors &&
        this.valueName in errors
      ) {
        errors = errors[this.valueName];
      }

      this.errors = errors;
    },
  },
};
</script>